import { render, staticRenderFns } from "./BookCentrePos.vue?vue&type=template&id=5b3ae79e&"
import script from "./BookCentrePos.vue?vue&type=script&lang=js&"
export * from "./BookCentrePos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports